module.exports = __webpack_public_path__ + "static/media/Share_Shorts_Grid_View_2.df9843b9.png";